import React, { useState } from 'react'

function CoreService() {
    const [corelist, setCoreList] = useState([
        {
            id: 0,
            title: "Ontime Delivery",
            icon: "images/web.png"
        },
        {
            id: 1,
            title: "Innovation",
            icon: "images/android.png"
        },
        {
            id: 2,
            title: "Satisfaction",
            icon: "images/sat.png"
        },
        {
            id: 3,
            title: "24/7 support",
            icon: "images/grp.png"
        },
    ])
    const coreservicelist = [
        {
            id: 0,
            title: "Web Development",
            image: "./images/web.jpeg"
        },
        {
            id: 0,
            title: "App Development",
            image: "./images/app.jpeg"
        },
        {
            id: 0,
            title: "Graphic Designing",
            image: "./images/graphic.jpeg"
        },
    ]
    return (
        <>
            <section id="services" className="services">
                <div className="container">
                    <div className="section-title" data-aos="fade-up">
                        <h2>My Services</h2>
                        <p></p>
                    </div>
                    <div className="row " style={{ color: "#33C5F" }}>
                        {
                            corelist.map((item, index) => {
                                return (
                                    <div key={item.id} className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
                                        <div className="icon-box" data-aos="fade-up" data-aos-delay="100" style={{ width: "100%" }}>
                                            <div className="icon bg-primary">
                                                <img width="60px" height="50px" src={item.icon} className=" p-1" />
                                            </div>
                                            <h4 className="title"><a href="#">{item.title}</a></h4>
                                            <p className="description"></p>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>
            </section>


            <section id="more-services" className="more-services">
                <div className="container ">
                    <div className="row">
                        {
                            coreservicelist.map((item, index) => {
                                return (
                                    <div key={item.id} className="col-md-4 d-flex align-items-stretch">
                                        <div
                                            className="card"
                                            style={{ backgroundImage: `url(${item.image})` }}
                                            data-aos="fade-up"
                                            data-aos-delay="100"
                                        >
                                            <div className="card-body" style={{ height: 50 }}>
                                                <h5 className="card-title">
                                                    <a href="#">{item.title}</a>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                </section>

                <div className="features container mt-4" id="features" >
                <div className="row" data-aos="fade-up" data-aos-delay="300">
                    <div className="col-lg-3 col-md-4">
                        <div className="icon-box">
                            <i className="ri-store-line" style={{ color: '#ffbb2c' }}></i>
                            <h3><a href="#">Android Development</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                        <div className="icon-box">
                            <i className="ri-bar-chart-box-line" style={{ color: '#5578ff' }}></i>
                            <h3><a href="#">IOS Development</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4 mt-md-0">
                        <div className="icon-box">
                            <i className="ri-calendar-todo-line" style={{ color: '#e80368' }}></i>
                            <h3><a href="#">Front-End Development</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4 mt-lg-0">
                        <div className="icon-box">
                            <i className="ri-paint-brush-line" style={{ color: '#e361ff' }}></i>
                            <h3><a href="#">Back-End Development</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-database-2-line" style={{ color: '#47aeff' }}></i>
                            <h3><a href="#">Databases</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-gradienter-line" style={{ color: '#ffa76e' }}></i>
                            <h3><a href="#">Responsive Site</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-file-list-3-line" style={{ color: '#11dbcf' }}></i>
                            <h3><a href="#">Landing Page</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-price-tag-2-line" style={{ color: '#4233ff' }}></i>
                            <h3><a href="#">Graphic Designing</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-anchor-line" style={{ color: '#b2904f' }}></i>
                            <h3><a href="#">Logo Designing</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-disc-line" style={{ color: '#b20969' }}></i>
                            <h3><a href="#">Website Designing</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-base-station-line" style={{ color: '#ff5828' }}></i>
                            <h3><a href="#">CRM Website</a></h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 mt-4">
                        <div className="icon-box">
                            <i className="ri-fingerprint-line" style={{ color: '#29cc61' }}></i>
                            <h3><a href="#">Web Application</a></h3>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CoreService